import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class TokenService {

    private token: string = '';
    private TOKEN: string = 'token';

    constructor() {
    }

    storeToken(token: string) {
        if (sessionStorage) {
            sessionStorage.setItem(this.TOKEN, token);
        }
        this.token = token;
    }

    getToken = function () {
        if (sessionStorage) {
            this.token = sessionStorage.getItem(this.TOKEN) || '';
        }
        return this.token;
    };
}
